import {
  createCycles,
  runDestroy,
  runMount,
  runPageOut,
  runPageIn,
} from "@/modules/_";

createCycles();
runPageIn();
runMount();

// modules
import { TextAnimations } from "@/modules/text-animations";

import { Accordion } from "@/modules/accordion";
import { CardBorder } from "@/modules/card-border";
import { CoinsAnimation } from "@/modules/coins-animation";
import { MarketsProgress } from "@/modules/markets-progress";
import { InfrastructureCard } from "@/modules/infrastructure-card";

const textAnimations = new TextAnimations();
textAnimations.init();
const accordion = new Accordion();
accordion.init();
const cardBorder = new CardBorder();
cardBorder.init();
const footerCoins = new CoinsAnimation('riveFooter', 'footerSection', -0.8, "top bottom", "bottom 20%")
footerCoins.init()
const marketsProgress = new MarketsProgress();
marketsProgress.init();
const infrastructureCard = new InfrastructureCard();
infrastructureCard.init();

history.scrollRestoration = "manual";
window.scrollTo(0, 0);